<template>
  <div class="home">
    Planner
  </div>
</template>

<script>
  export default {}
</script>
